export interface AgreementBlock {
  paragraphs?: string[];
  bullets?: string[];
  imageUrl?: string;
  imageCaption?: string;
  imageAlt?: string;
}

export interface AgreementSection {
  title: string;
  blocks: AgreementBlock[];
}

export interface AgreementDocument {
  title: string;
  sections: AgreementSection[];
}

export const USER_AGREEMENT: AgreementDocument = {
  title: '用户协议',
  sections: [
    {
      title: '第一条 协议主体与适用范围',
      blocks: [
        {
          paragraphs: [
            '1.1 本用户协议是您（以下简称 “用户”）与爱普生（中国）有限公司上海分公司（平台运营主体）之间，就访问、注册、使用【星云平台】网站服务所订立的有效合约。南京功夫豆科技股份有限公司仅为平台技术搭建服务商，负责网站技术搭建，不承担平台运营服务及本协议项下平台运营相关责任。',
            '1.2 本协议适用于中国大陆地区全体平台用户，凡注册、访问、浏览、使用本平台服务，即表示您已仔细阅读、完全理解并自愿接受本协议全部条款；若您不接受本协议条款，请立即停止使用本平台服务。',
            '1.3 本平台定位：对接打印打样供需的撮合平台，为有打印打样需求的客户与打样服务供应商提供信息对接、商品展示、交易撮合、支付结算相关服务。',
          ],
        },
      ],
    },
    {
      title: '第二条 用户注册与账号使用',
      blocks: [
        {
          paragraphs: [
            '2.1 注册要求：用户注册时须提供真实有效的公司名称、手机号码并完成绑定核验，确保信息真实有效、归属本人 / 本企业；手机号用于账号核验、通知接收、交易沟通。',
            '2.2 账号责任：用户对本人账号下全部操作、交易、上传内容承担全部责任，妥善保管账号信息、验证码及登录权限，严禁转借、共用账号；因账号保管不当产生的全部损失由用户自行承担。',
            '2.3 资质合规：供应商用户需保证自身具备合法经营资质、可提供合规打印打样服务；需求方用户保证所上传打样图片 / 素材具备完整版权、授权，不侵犯第三方知识产权、肖像权、著作权等合法权益，不包含违法违规内容。',
            '2.4 平台审核：平台有权对用户资料、上传素材进行合规核查，发现虚假信息、违规素材可采取警告、限制功能、临时封禁账号等措施。',
          ],
        },
      ],
    },
    {
      title: '第三条 平台服务规则',
      blocks: [
        {
          paragraphs: [
            '3.1 核心服务：平台展示打样供应商商品信息，撮合需求用户与供应商达成打样服务订单；供应商可上传商品展示图片，需求用户可上传待打样样图，仅用于对应打样服务履约。',
            '3.2 图片素材使用：用户上传的打样样图，仅限对应签约供应商下载、用于本次打样履约，不得挪作他用、二次分发、商用转载；服务履约完成后供应商不得继续留存、使用该样图。',
            '3.3 付款结算：平台支持微信支付、支付宝支付、平台代金券抵扣三种付款方式，用户确认订单并完成支付后，由对应供应商提供打样服务；价格、交付周期、样品规格以订单页面约定为准。',
            '3.4 退款规则：本平台无会员、积分体系，无自动退款机制；如产生退款需求，用户需通过平台企微客服渠道提交申请，由供需双方协商处理，平台仅提供沟通协助，不直接承担商品 / 服务质量赔付责任，最终退款结果以供需双方协商结果为准。',
            '3.5 数据统计：平台会进行基础订单数据、商品收藏量统计，仅用于平台运营优化、服务迭代，不会对外泄露可定位个人的原始信息。',
            '3.6 无 AI 生成内容：本平台未使用 AI 模型生成内容，所有展示图片、素材均由人工上传。',
          ],
        },
      ],
    },
    {
      title: '第四条 用户禁止行为',
      blocks: [
        {
          paragraphs: [
            '4.1 严禁上传、发布、传播色情、暴力、违法、侵权、违反公序良俗的图片、文字及信息；严禁利用平台从事非法经营、诈骗、恶意刷单、恶意投诉等违规行为。',
            '4.2 严禁恶意篡改平台页面、攻击服务器、爬虫盗刷数据、干扰平台正常运营。',
            '4.3 如有违反本条约定，平台有权限制账号功能、冻结交易、封禁账号，并保留追究法律责任的权利；由此造成的损失由违规用户自行承担。',
          ],
        },
      ],
    },
    {
      title: '第五条 知识产权约定',
      blocks: [
        {
          paragraphs: [
            '5.1 供应商上传商品图片：知识产权归属上传供应商本人，供应商保证拥有完整版权及授权；',
            '5.2 用户上传打样样图：知识产权归属原图权利人，仅限本次打样履约使用；未经权利人书面许可，任何一方不得复制、商用、二次传播；',
            '5.3 平台整体页面设计、系统代码、品牌标识等知识产权归属平台运营方，未经书面许可不得复制盗用。',
          ],
        },
      ],
    },
    {
      title: '第六条 免责声明',
      blocks: [
        {
          paragraphs: [
            '6.1 平台仅为供需撮合信息平台，并非打样服务实际提供者，打样产品质量、材质、交付、售后纠纷，由需求用户与供应商双方直接沟通处理，平台不承担连带产品质量责任。',
            '6.2 因不可抗力、运营商网络故障、第三方支付故障、用户自身操作失误、设备问题造成的损失，平台不承担赔偿责任。',
            '6.3 平台仅在法定责任范围内承担相应责任，不承担间接损失、预期收益损失。',
          ],
        },
      ],
    },
    {
      title: '第七条 协议修改与通知',
      blocks: [
        {
          paragraphs: [
            '7.1 平台可根据运营及合规需要修订本用户协议，修订版本将在平台网站公示，公示后继续使用平台即视为同意新版协议。',
            '7.2 重要通知将通过绑定手机号短信、平台站内消息或企微客服渠道送达。',
          ],
        },
      ],
    },
    {
      title: '第八条 账号注销与数据处理',
      blocks: [
        {
          paragraphs: [
            '8.1 当前平台暂未开放自助账号注销功能，如需账号注销及相关个人信息删除服务，请联系平台企微客服沟通处理，完成核验后按合规流程处理；',
            '8.2 合规留存：平台需依法留存交易、财税相关订单信息，此类信息会按照法律法规要求留存，无法直接删除。',
          ],
        },
      ],
    },
    {
      title: '第九条 争议解决',
      blocks: [
        {
          paragraphs: [
            '9.1 本协议适用中华人民共和国大陆地区法律。',
            '9.2 因本协议及平台服务产生争议，各方优先通过客服协商解决；协商不成，提交平台运营主体所在地有管辖权的人民法院诉讼解决。',
            '9.3 客服沟通渠道：平台企业微信客服（9：00-19：00）',
          ],
          imageUrl: 'https://cdn-h.gongfudou.com/Epson/customer_service.png',
          imageCaption: '微信扫描二维码，添加专属客服',
          imageAlt: '客服微信二维码',
        },
      ],
    },
  ],
};

export const PRIVACY_POLICY: AgreementDocument = {
  title: '隐私政策',
  sections: [
    {
      title: '第一条 前言与适用范围',
      blocks: [
        {
          paragraphs: [
            '1.1 本隐私政策说明【星云平台】如何收集、存储、使用、保护您的个人信息，仅适用于本平台网站服务，不适用于外部跳转第三方网站。',
            '1.2 本平台面向中国大陆用户，遵循《中华人民共和国个人信息保护法》《网络安全法》《电子商务法》等法律法规处理个人信息。',
            '1.3 继续使用本平台服务，即代表您同意本隐私政策约定的信息处理规则。',
          ],
        },
      ],
    },
    {
      title: '第二条 我们收集的个人信息',
      blocks: [
        {
          paragraphs: ['2.1 必要收集信息'],
          bullets: [
            '手机号码：用于账号注册验证、身份核验、订单通知、交易沟通、安全风控',
            '公司名称：用于企业用户身份识别、订单对账、商务履约',
            '所在城市：用于服务匹配、区域运营优化、履约配送参考',
          ],
        },
        {
          paragraphs: ['2.2 非个人信息'],
          bullets: [
            '匿名化统计信息：整体订单数据、商品收藏总量（非可定位到单一个人 / 企业的匿名统计数据）',
            '用户上传打样图片、供应商商品图片：不属于法定个人信息，仅用于履约及商品展示',
          ],
        },
        {
          paragraphs: ['2.3 信息收集说明'],
          bullets: [
            '无第三方登录功能，不通过第三方渠道获取个人信息；',
            '无 AI 模型，不会通过 AI 采集、分析个人信息；',
            '支付信息：微信 / 支付宝支付由微信、支付宝官方支付机构处理，平台不存储银行卡、完整支付密码等支付敏感信息，仅获取订单支付状态信息。',
          ],
        },
      ],
    },
    {
      title: '第三条 信息使用目的',
      blocks: [
        {
          paragraphs: [
            '3.1 账号验证与安全管理：核验账号身份、保障账号安全、防范诈骗和异常交易',
            '3.2 订单履约：完成打样订单对接、沟通、交付、售后沟通',
            '3.3 平台运营优化：基于整体订单、收藏数据优化平台功能、改善服务体验（采用匿名聚合统计，不单独追踪个人）',
            '3.4 合规监管：履行税务、电商监管、反诈风控等法定合规义务',
            '3.5 客服沟通：用于用户咨询、退款沟通、售后问题处理',
            '我们不会将您的可识别个人信息（手机号、公司名称、城市信息）出售、共享给无关第三方，除非取得您书面同意，或法律法规、司法机关要求披露。',
          ],
        },
      ],
    },
    {
      title: '第四条 信息存储与安全保护',
      blocks: [
        {
          paragraphs: ['4.1 存储地域：用户个人信息仅存储于中国大陆境内合规服务器。'],
        },
        {
          paragraphs: ['4.2 存储期限：'],
          bullets: [
            '基础账号信息：账号存续期间保存；账号注销后，除法定合规留存信息外，按合规流程删除',
            '交易订单信息：依照国家财税、电商监管法规进行留存',
            '打样图片：履约完成后不再留存原始样图',
          ],
        },
        {
          paragraphs: [
            '4.3 安全保障：采用行业标准技术加密、访问权限管控等方式保护数据，防止信息泄露、篡改、被盗；但无法做到绝对安全，用户也需做好自身账号密码防护。',
          ],
        },
      ],
    },
    {
      title: '第五条 用户权利',
      blocks: [
        {
          paragraphs: [
            '5.1 查询 / 更正信息：用户可联系企微客服，核验身份后查询、更正本人绑定手机号、公司名称、所在城市信息',
            '5.2 删除 / 注销：如需删除个人信息、注销账号，联系平台企微客服核验身份后处理（法定强制留存信息除外）',
            '5.3 撤回同意：若您不再同意信息处理规则，可停止使用平台服务并申请注销账号',
            '5.4 投诉反馈：可通过平台企微客服反馈隐私相关问题',
          ],
        },
      ],
    },
    {
      title: '第六条 第三方服务说明',
      blocks: [
        {
          paragraphs: [
            '6.1 支付服务：微信支付、支付宝，适用微信 / 支付宝官方隐私政策，平台不承担支付渠道隐私处理责任',
            '6.2 其余无第三方数据统计 SDK、第三方登录 SDK、AI 模型 SDK，无额外第三方信息采集',
          ],
        },
      ],
    },
    {
      title: '第七条 未成年人提示',
      blocks: [
        {
          paragraphs: ['本平台主要面向企业商用用户，不面向未成年人提供服务；未成年人请勿注册及使用本平台。'],
        },
      ],
    },
    {
      title: '第八条 政策更新',
      blocks: [
        {
          paragraphs: ['本隐私政策可根据法律法规更新进行修订，修订版本在官网公示生效；持续使用即视为接受更新版本。'],
        },
      ],
    },
    {
      title: '第九条 联系方式',
      blocks: [
        {
          paragraphs: ['客服渠道：平台企业微信客服（9：00-19：00）'],
          imageUrl: 'https://cdn-h.gongfudou.com/Epson/customer_service.png',
          imageCaption: '微信扫描二维码，添加专属客服',
          imageAlt: '客服微信二维码',
        },
      ],
    },
  ],
};
